import { httpRequest } from "@services/http";
import { bannersUrl, type Banner } from "./cmdListBanners";
import type { BannerPayload } from "./cmdCreateBanner";

export class CommandUpdateBanner {
  /** PATCH is partial on the server: a key left out is kept, and ends_at: null clears the end. */
  async run(uuid: string, payload: Partial<BannerPayload>): Promise<Banner> {
    try {
      return await httpRequest<Banner>(`${bannersUrl()}${uuid}/`, { method: "PATCH", body: payload });
    } catch (error) {
      console.error("Error updating banner:", error);
      throw error;
    }
  }
}
